module.exports = __webpack_public_path__ + "media/categories/2029-72b5aaf6.svg";